import { Component, OnInit, Input } from '@angular/core';
import { Member } from 'src/app/model/member';
import { MemberService } from 'src/app/services/member.service';

@Component({
  selector: 'member-overview-list',
  templateUrl: 'member-overview-list.html'
})

export class MemberOverviewListComponent implements OnInit {
  @Input("roleId") roleId: string;
  @Input("underAge") underAge: number = 200;
  @Input("overAge") overAge: number = 0;
  members: Member[];

  constructor(private readonly memberService: MemberService) { }

  ngOnInit(): void {
    this.getMembers();
  }

  getMembers(): void {
    this.memberService.getMembers().subscribe(members => {
      this.members = members.filter(member => member.roleIds.includes(this.roleId) &&
        new Date(member.dayOfBirth).getFullYear() < this.getYearFromAge(this.overAge) &&
        new Date(member.dayOfBirth).getFullYear() >= this.getYearFromAge(this.underAge));
    })
  }

  private getYearFromAge(age: number): number {
    let date = new Date();
    date.setMonth(date.getMonth() + 4);
    date.setFullYear(date.getFullYear() - age);
    return date.getFullYear();
  }
}
